import {Link} from "react-router-dom";
import ContactStillNeedHelpComponent from "../../components/contact/ContactStillNeedHelpComponent.tsx";
import ContactPageLayout from "./ContactPageLayout.tsx";

export default function ContactSetupPage() {
    return (
        <ContactPageLayout
            meta_title={"Opsætning af router"}
            meta_description={"Find vejledning omkring opsætning af router her. Læs om placering af router, installationsvejledning og hvordan du skifter navn og kode."}
            title={"Opsætning af router"}
            className={"page-contact-setup"}
            content={
                <>
                    <section className="contact-content">
                        <p>
                            Her er tre artikler, der kan hjælpe dig med opsætningen af din router:
                        </p>
                        <Link
                            to={'/hjaelp/internet-og-wifi/placering-af-router'}
                            className={'button button--montserrat teal'}
                        >Placering af router</Link>
                        <Link
                            to={'/hjaelp/udstyr/installationsmanual'}
                            className={'button button--montserrat teal'}
                        >Installationsvejledning til router</Link>
                        <Link
                            to={'/hjaelp/internet-og-wifi/skift-navn-og-kode-paa-wifi'}
                            className={'button button--montserrat teal'}
                        >Skift navn og kode på wifi</Link>
                    </section>

                    <ContactStillNeedHelpComponent phone={true}/>
                </>
            }
        />
    )
}
